import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { PhotoUploadModule } from 'app/assessment/photo-upload/photo-upload.module';
import { QuestionsModule } from 'app/assessment/questions/questions.module';
import { SurveyEffects, surveyReducer } from 'app/assessment/survey/state';
import { AssessmentUtilitiesModule } from 'app/assessment/utilities/assessment-utilities.module';
import { MaterialModule } from 'app/material.module';
import { SharedModule } from 'app/shared/shared.module';

import { SurveyReportDialogComponent } from './components/survey-report-dialog/survey-report-dialog.component';
import { SurveyStepperComponent } from './components/survey-stepper/survey-stepper.component';
import { SurveyComponent } from './components/survey.component';
import { SurveyRestConnectorService } from './services/survey-rest-connector.service';
import { SurveyService } from './services/survey.service';
import { routedComponents, SurveyRoutingModule } from './survey-routing.module';

@NgModule({
  imports: [
    StoreModule.forFeature('survey', surveyReducer),
    EffectsModule.forFeature([
      SurveyEffects,
    ]),
    CommonModule,
    SharedModule,
    SurveyRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    QuestionsModule,
    PhotoUploadModule,
    AssessmentUtilitiesModule,
    TranslateModule,
  ],
  providers: [
    SurveyService,
    SurveyRestConnectorService,
    SurveyEffects,
  ],
  exports: [
    SurveyComponent,
    SurveyReportDialogComponent,
  ],
  declarations: [
    routedComponents,
    SurveyStepperComponent,
    SurveyReportDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SurveyModule { }
